import HCMLanding from '~/views/Manage/Landing';
//import LibLanding from '~/views/Develop/Landing';
//
//import CommunityHome from '~/views/Community/Community/Home';
//import Profile from '~/views/Community/Community/Profile';
//import Blogs from '~/views/Community/Community/Blogs';
//import Forums from '~/views/Community/Community/Forums';
//import DepartmentFeed from '~/views/Community/Community/Forums/DepartmentFeed';
//import IndividualTopic from '~/views/Community/Community/Forums/IndividualTopic';
//import DepartmentHome from '~/views/Community/Departments/Home';
//import Network from '~/views/Community/Community/Network';
//
//import VendorHome from '~/views/VendorRatings/Home';
//import ByCategory from '~/views/VendorRatings/ByCategory';
//import ByCategoryDetail from '~/views/VendorRatings/ByCategoryDetail';
//import ByCompany from '~/views/VendorRatings/ByCompany';
//import ByName from '~/views/VendorRatings/ByName';
//import RateVendor from '~/views/VendorRatings/RateVendor';
//import AddVendor from '~/views/VendorRatings/AddVendor';
//import BuyerGuide from '~/views/VendorRatings/BuyerGuide';
//import DealerSatisfactionAward from '~/views/VendorRatings/DealerSatisfactionAward';
//import FAQ from '~/views/VendorRatings/FAQ';
//import VendorSearch from '~/views/VendorRatings/VendorSearch';
//import CompanyMgt from '~/views/VendorRatings/CompanyMgt';
//import ContentMgt from '~/views/VendorRatings/ContentMgt';
//import FeaturedContent from '~/views/VendorRatings/FeaturedContent';
//import UserMgt from '~/views/VendorRatings/UserMgt';
//import VRCategoryMgt from '~/views/VendorRatings/VRCategoryMgt';
//import VRRatingMgt from '~/views/VendorRatings/VRRatingMgt';
//
//import AnlLanding from '~/views/Analytics/Landing';
//import EvtLanding from '~/views/Events/Landing';
//
//import Slug from '~/views/Slug';

const publicRoutes = [
    { path: '/hcm', component: HCMLanding },
    //{ path: '/library', component: LibLanding },
    //{ path: '/analytics', component: AnlLanding },

    //{ path: '/community/home', component: CommunityHome },
    //{ path: '/community/profile', component: Profile },
    //{ path: '/community/blogs', component: Blogs },
    //{ path: '/forums', component: Forums },
    //{ path: '/community/forums/:topicId/:departId', component: IndividualTopic },
    //{ path: '/community/network', component: Network },
    //{ path: '/community/departments/:department', component: DepartmentHome },
    //{ path: '/community/forum-department-feed/:departId', component: DepartmentFeed },

    //{ path: '/events', component: EvtLanding },

    //{ path: '/vendor-ratings/home', component: VendorHome },
    //{ path: '/vendor-ratings/by-category', component: ByCategory },
    //{ path: '/vendor-ratings/by-category/:id', component: ByCategoryDetail },
    //{ path: '/vendor-ratings/by-company', component: ByCompany },
    //{ path: '/vendor-ratings/dealer-satisfaction-award', component: DealerSatisfactionAward },
    //{ path: '/vendor-ratings/buyer-guide', component: BuyerGuide },
    //{ path: '/vendor-ratings/faq', component: FAQ },
    //{ path: '/vendor-ratings/search', component: VendorSearch },
    //{ path: '/vendor-ratings/company-mgt', component: CompanyMgt },
    //{ path: '/vendor-ratings/content-mgt', component: ContentMgt },
    //{ path: '/vendor-ratings/featured-content', component: FeaturedContent },
    //{ path: '/vendor-ratings/user-mgt', component: UserMgt },
    //{ path: '/vendor-ratings/vr-category-mgt', component: VRCategoryMgt },
    //{ path: '/vendor-ratings/vr-rating-mgt', component: VRRatingMgt },

    //{ path: '/forums/:category', component: Forums },
    //{ path: '/forums/:category/:topic', component: Forums },
    //{ path: '/business', component: Slug },

    //{ from: '/community', to: '/community/home' },
    //{ from: '/vendor-ratings', to: '/vendor-ratings/home' },
    // Commented out dynamic routes:
    // { path: '/:entity', component: Slug },
    // { path: '/:entity/:product', component: Slug },
    // { path: '/in/:entity/blog', component: Slug },
    // { path: '/:entity/blog/:post', component: Slug },
];

export default publicRoutes;
